import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';
import * as stateObjects from './stateObjects';

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  actions,
  mutations,
  getters,
  state: {
    debug: {
      questions: false,
      navigation: false,
    },
    redirectRoute: null,
    constants: {
      questionTypes: {},
      questionTypeOptions: {},
      displayTypes: {},
      displayTypeOptions: {},
      completenessValidationTypes: {},
      roleLevels: {}
    },
    windowWidth: window.innerWidth,
    auth: Object.assign({}, stateObjects.auth()),
    themes: {
      green: {
        primaryColor: '#389466',
        loginImage: 'card-green.png'
      }
    },
    surveys: [],
    orgSurveys: [],
    previousSectionId: null,
    activeSectionId: null,
    activeSurveyInitialized: false,
    activeSurvey: Object.assign({}, stateObjects.activeSurvey()),
    activeColorScheme: 'primary',
    activeSurveyNavSections: [],
    activeSurveyReports: {
      statistics: {
        orgSurvey: {
          sections: []
        }
      }
    },
    surveyUser: {
      orgSurveyUserId: null,
      userSurveyStatusId: null,
      lastSectionId: null,
      responses: []
    }
  }
});

export default store;
